module.exports = __webpack_public_path__ + "static/media/logo.0fd3ac33.png";